import Index from '@tunnel-components/@sharded/@widgets/virtualized/pagination/container'

/**
 * @export Container
 */

export default Index


// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@widgets/virtualized/pagination/index.ts